/**
 * Parse "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm:ss..." as local date (midnight local time).
 * Avoids UTC interpretation that shifts the date in negative-UTC timezones.
 */
export function parseDateLocal(dateStr: string): Date {
  const dateOnly = dateStr.includes("T") ? dateStr.split("T")[0]! : dateStr;
  const [y, m, d] = dateOnly.split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
}

/**
 * Format Date as "YYYY-MM-DD" using local date parts.
 */
export function toDateStringLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * If the date is Saturday (6) or Sunday (0), returns the next Monday.
 * Otherwise returns the same date (new Date with same year/month/day).
 */
export function proximoDiaUtil(d: Date): Date {
  const copy = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const day = copy.getDay(); // 0 = Sunday, 6 = Saturday
  if (day === 0) copy.setDate(copy.getDate() + 1); // Sunday -> Monday
  else if (day === 6) copy.setDate(copy.getDate() + 2); // Saturday -> Monday
  return copy;
}
